import { render, staticRenderFns } from "./DontMissCard.vue?vue&type=template&id=6d464f83"
import script from "./DontMissCard.ts?vue&type=script&lang=ts&external"
export * from "./DontMissCard.ts?vue&type=script&lang=ts&external"
import style0 from "./DontMissCard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports